
const initialState = {}

// REDUCERS
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'editData@userGuest': {
			return {
				...state,
				[action.field]: action.value,
			}
		}

		default: return state
	}
}
